<template>
  <div
    class="fixed w-full min-h-screen max-h-screen flex items-center justify-center bg-black bg-opacity-30 top-0 left-0 right-0"
  >
    <div
      class="p-6 w-11/12 rounded-lg max-w-md bg-white font-bold max-h-[90vh] overflow-y-auto"
    >
      <h3 class="text-center text-xl">Add Charge Station</h3>
      <div class="w-full flex items-center justify-between gap-3">
        <div class="w-full">
          <input
            type="text"
            placeholder="Name"
            v-model="name"
            class="font-normal border border-realBlack border-opacity-40 w-full py-2 px-6 rounded-md mt-7"
          />
        </div>
      </div>
      <input
        type="text"
        placeholder="Address"
        v-model="address"
        class="font-normal border border-realBlack border-opacity-40 w-full py-2 px-6 rounded-md mt-3"
      />
      <div class="flex items-center justify-between gap-4">
        <input
          type="number"
          placeholder="Latitude"
          v-model="lat"
          class="font-normal border border-realBlack border-opacity-40 w-full py-2 px-6 rounded-md mt-3"
        />
        <input
          type="number"
          placeholder="Longitude"
          v-model="lon"
          class="font-normal border border-realBlack border-opacity-40 w-full py-2 px-6 rounded-md mt-3"
        />
      </div>
      <!-- <input
        type="text"
        placeholder="Chargers"
        v-model="chargers"
        class="font-normal border border-realBlack border-opacity-40 w-full py-2 px-6 rounded-md mt-3"
      /> -->
      <label class="inline-block mt-3"
        >Open Hours: <br />
        <sub class="leading-[-1px]"
          >(Strict Format: <br />
          Mondays - Fridays: 8AM - 5PM, Saturdays: 9AM - 2PM )</sub
        ></label
      >
      <input
        type="text"
        placeholder="Open Hours"
        v-model="open_hours"
        class="font-normal border border-realBlack border-opacity-40 w-full py-2 px-6 rounded-md"
      />

      <label class="inline-block mt-3">Upload Photo</label>
      <input
        type="file"
        name="photo"
        accept="image/png, image/jpeg"
        @change="handleFileChange"
      />

      <div class="w-full mt-6">
        <h6>Chargers</h6>
        <div class="flex items-center justify-between gap-3 mt-2">
          <div class="w-full">
            <div v-for="(types, type) in chargersType" :key="type" class="mb-6">
              <div class="font-bold">{{ type }}</div>
              <div class="grid grid-cols-2 flex-wrap gap-2 mb-1">
                <div class="col-span-full">
                  <label class="text-sm block" for="">Count</label>
                  <input
                    type="number"
                    min="1"
                    placeholder="Count"
                    v-model.number="parentChargerDetails[type].count"
                    class="w-full py-1 px-2 border border-realBlack border-opacity-40 rounded-md"
                  />
                </div>
                <div class="">
                  <label class="text-sm block" for="">Power Rating (kW)</label>
                  <input
                    type="number"
                    min="1"
                    placeholder="Power Rating (kW)"
                    v-model.number="parentChargerDetails[type].power_rating"
                    class="w-full py-1 px-2 border border-realBlack border-opacity-40 rounded-md"
                  />
                </div>
                <div class="">
                  <label class="text-sm block" for="">Price per kwh</label>
                  <input
                    type="number"
                    min="1"
                    placeholder="Price per kwh"
                    v-model.number="parentChargerDetails[type].price_per_kwh"
                    class="w-full py-1 px-2 border border-realBlack border-opacity-40 rounded-md"
                  />
                </div>
              </div>
              <div class="grid grid-cols-2 gap-4 mt-4">
                <div
                  v-for="charger in types"
                  :key="charger"
                  class="flex items-center gap-2 mb-1"
                >
                  <input
                    type="checkbox"
                    :id="`charger-${type}-${charger}`"
                    v-model="parentChargerDetails[type].connector_types"
                    :value="charger"
                    class="mr-2"
                  />
                  <label :for="`charger-${type}-${charger}`" class="mr-2">{{
                    charger
                  }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="flex justify-between mt-5 gap-3">
        <button
          @click="submit"
          class="bg-realBlack border-realBlack w-1/2 flex items-center justify-center text-white font-medium py-2 px-6 rounded-lg cursor-pointer"
        >
          <Spinner v-if="sending" />
          <span v-else> Submit </span>
        </button>
        <button
          @click="closeModal()"
          class="bg-gray-500 text-white w-1/2 font-medium py-2 px-6 rounded-lg cursor-pointer"
        >
          Cancel
        </button>
      </div>
    </div>
  </div>
</template>

<script>
// import axios from "axios";
import Spinner from "./Spinner.vue";

const chargersType = {
  AC: ["Type 1", "Type 2", "Tesla"],
  DC: ["GBT", "CCS2"],
};

export default {
  components: { Spinner },
  props: ["closeModal"],
  setup() {
    return { chargersType };
  },
  data() {
    return {
      sending: false,
      name: "",
      address: "",
      lat: "",
      lon: "",
      chargers: "",
      open_hours: "",
      photo: null,
      selectedChargers: [],
      parentChargerDetails: {
        AC: {
          count: 0,
          price_per_kwh: 0,
          connector_types: [],
          power_rating: 0,
        },
        DC: {
          count: 0,
          price_per_kwh: 0,
          connector_types: [],
          power_rating: 0,
        },
      },
    };
  },
  // watch: {
  //   parentChargerDetails: {
  //     handler(newVal) {
  //       console.log(newVal);

  //     },
  //     deep: true,
  //   },
  // },
  methods: {
    handleFileChange(event) {
      const file = event.target.files[0];
      if (!file) {
        this.photo = null;
        return;
      }
      // Validate file type
      if (!["image/png", "image/jpeg"].includes(file.type)) {
        this.$toast.warn('Only PNG and JPEG files are allowed.');
        return;
      }

      if (file && file.size > 10 * 1024 * 1024) {
        this.$toast.warn('File size exceeds 10MB limit.');
        return;
      }
      this.photo = file;
    },

    async submit() {
      // Validate inputs
      if (this.name.length < 2) {
        return this.$toast.warn('Name is too short');
      }
      if (this.address.length < 5) {
        return this.$toast.warn('Address is too short');
      }
      if (this.lat === '' || this.lon === '') {
        return this.$toast.warn('Latitude and Longitude are required');
      }
      // if (this.chargers === "") {
      //   return alert("Chargers field is required");
      // }
      const openHoursRegex =
        /^Mondays - Fridays: (?:1[0-2]|0?[1-9])(?:\:[0-5][0-9])?\s?(?:AM|PM)\s*-\s*(?:1[0-2]|0?[1-9])(?:\:[0-5][0-9])?\s?(?:AM|PM)(?:,\s*Saturdays: (?:1[0-2]|0?[1-9])(?:\:[0-5][0-9])?\s?(?:AM|PM)\s*-\s*(?:1[0-2]|0?[1-9])(?:\:[0-5][0-9])?\s?(?:AM|PM))?$/i;
      if (!openHoursRegex.test(this.open_hours)) {
        return this.$toast.warn('Open hours format is incorrect');
      }
      if (!this.photo) {
        return this.$toast.warn('Please upload a photo');
      }
      if (this.photo && this.photo.size > 10 * 1024 * 1024) {
        return this.$toast.warn('File size exceeds 10MB limit.');
      }

      // vaidate chargers details it's allowed to be empty but not half filled and at the same time we need at least one to be completed
      const acDetails = this.parentChargerDetails.AC;
      const dcDetails = this.parentChargerDetails.DC;
      if (
        (acDetails.count > 0 && acDetails.price_per_kwh > 0) ||
        (dcDetails.count > 0 && dcDetails.price_per_kwh > 0)
      ) {
        // Valid
      } else {
        return this.$toast.warn('Please fill at least one charger type with details');
      }

      if (
        (acDetails.count > 0 && acDetails.connector_types.length === 0) ||
        (dcDetails.count > 0 && dcDetails.connector_types.length === 0)
      ) {
        return this.$toast.warn('Please select at least one connector type for the filled charger type');
      }

      if (
        (acDetails.count > 0 &&
          (!acDetails.power_rating || acDetails.power_rating <= 0)) ||
        (dcDetails.count > 0 &&
          (!dcDetails.power_rating || dcDetails.power_rating <= 0))
      ) {
        return this.$toast.warn('Please enter a valid power rating for the filled charger type');
      }
      // Only include chargers with complete details (count > 0, price_per_kwh > 0, and at least one connector type)
      this.chargers = Object.entries(this.parentChargerDetails)
        .filter(
          ([, details]) =>
            details.count > 0 &&
            details.price_per_kwh > 0 &&
            Array.isArray(details.connector_types) &&
            details.connector_types.length > 0
        )
        .map(([chargerType, details]) => ({
          charger_type: chargerType,
          count: details.count,
          price_per_kwh: details.price_per_kwh,
          connector_types: details.connector_types,
          power_rating: details.power_rating, // Include power rating
        }));

      // return console.log(JSON.stringify(this.chargers));

      var formData = new FormData();
      formData.append("name", this.name);
      formData.append("address", this.address);
      formData.append("lat", this.lat);
      formData.append("lon", this.lon);
      formData.append("chargers", JSON.stringify(this.chargers));
      formData.append("open_hours", this.open_hours);
      formData.append("photo", this.photo);

      // var payload = {
      //   path: "/admin/auth/register",
      //   data: {
      //     first_name: this.first_name,
      //     last_name: this.last_name,
      //     email: this.email,
      //   },
      // };
      try {
        this.sending = true;
        fetch(
          process.env.VUE_APP_SERVER_BASE_URL + "/admin/api/charge-stations",
          {
            method: "POST",
            body: formData,
            headers: {
              authorization: `Bearer ${this.$store.state.token}`,
            },
          }
        )
          .then((response) => response.json())
          .then((data) => {
            this.$toast.success(data.message);
            this.sending = false;
            // reset form fields
            this.name = "";
            this.address = "";
            this.lat = "";
            this.lon = "";
            this.chargers = "";
            this.open_hours = "";
            this.photo = null;
            this.closeModal();
          })
          .catch((error) => {
            console.error('Error:', error);
            this.$toast.error('An error occurred');
          });

        // const response = await this.$store.dispatch("postRequest", payload);
        // alert(response.data.message);
        // this.closeModal();
      } catch (error) {
        // if (axios.isAxiosError(error) && error.response) {
        //   alert(error.response.data.message);
        // } else {
        //   alert("An error ocurred");
        // }
      }
      this.sending = false;
    },
  },
};
</script>

<style>
</style>